import styled from 'styled-components';

import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import {
  SecondaryButtonIcon,
  SecondaryButtonIconProps,
} from 'approot/shared/styles/buttons/secondary-button.style';
import { PrimaryButtonIcon } from 'approot/shared/styles/buttons/primary-button.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';
import { WorksheetCardWrapper } from 'approot/shared/worksheet-card/worksheet-card.style';
import { SimpleCardInner } from 'approot/shared/simple-card/simple-card.style';

const ACTION_BAR_HEIGHT_AND_PADDING = 88;

type ActivitiesProps = {
  bannerHeight: number;
};
export const ActivityContainer = styled.div<ActivitiesProps>`
  position: sticky;
  top: ${({ bannerHeight = 0 }) =>
    rem(
      LAYOUT_HEADER_HEIGHT - 1 + bannerHeight + ACTION_BAR_HEIGHT_AND_PADDING
    )};

  ${WorksheetCardWrapper} {
    margin-bottom: 0;
  }
`;

type ActivityCarouselProps = {
  $isLoading?: boolean;
};
export const ActivityCarousel = styled.div<ActivityCarouselProps>`
  margin-bottom: ${rem(spacing16)};
  position: relative;

  ${SimpleCardInner} {
    ${({ $isLoading }) =>
      $isLoading
        ? `
      opacity: 0;
    `
        : `
      opacity: 1;
      transition: opacity 300ms ease;
    `};
  }
`;

type LessonActivitiesCarouselButtonProps = {
  $isNext?: boolean;
};
export const ActivityCarouselButton = styled(SecondaryButtonIcon).attrs<
  LessonActivitiesCarouselButtonProps & SecondaryButtonIconProps
>({
  $borderRadius: 34,
})`
  position: absolute;
  margin-top: -${rem(34)};
  width: ${rem(68)};
  height: ${rem(68)};
  top: 50%;
  z-index: 2;

  &:focus {
    box-shadow: inset ${baseBoxShadowFocus};
    outline: 0;
  }

  ${({ $isNext }) =>
    $isNext
      ? `
    right: ${rem(spacing16)};
  `
      : `
    left: ${rem(spacing16)};
  `}
`;

export const ActivityThumbnails = styled.div.attrs<{
  'data-selector'?: string;
}>({
  'data-selector': 'activity-thumbnails',
})`
  position: relative;
`;

export const ActivityThumbnailsScroll = styled.div`
  overflow-y: scroll;
  scroll-snap-type: x mandatory;
`;

export const ActivityThumbnailsWrapper = styled.div`
  display: flex;
  gap: ${rem(spacing16)};
  padding: ${rem(2)} ${rem(4)} ${rem(spacing16)} ${rem(4)};
`;

export const ActivityThumbnail = styled.div.attrs<{
  'data-selector'?: string;
}>({
  'data-selector': 'content-card-box',
})`
  background-color: ${grey1};
  flex-shrink: 0;
  width: ${rem(170)};
  position: relative;
`;

type ActivityThumbnailButtonProps = {
  $isNext?: boolean;
};
export const ActivityThumbnailButton = styled(PrimaryButtonIcon).attrs({
  $borderRadius: 18,
  $isSmall: true,
})<ActivityThumbnailButtonProps>`
  position: absolute;
  margin-top: -${rem(48 / 2)};
  top: 50%;
  z-index: 10;

  ${({ $isNext }) =>
    $isNext
      ? `
    right: -${rem(spacing16)};
  `
      : `
    left: -${rem(spacing16)};
  `}
`;

export const ActivityWorksheetThumbnail = styled.div`
  background-color: ${grey1};
  flex-shrink: 0;
  width: ${rem(170)};
  position: relative;
`;
